
<template>
        <div class="row justify-content-center" :dir="language">
            <div class="col-lg-5 col-md-7">
                <div class="card bg-secondary shadow border-0">
<!--                     <div class="card-header bg-transparent pb-5">
                        <div class="text-muted text-center mt-2 mb-3"><small>Sign in with</small></div>
                        <div class="btn-wrapper text-center">
                            <a href="#" class="btn btn-neutral btn-icon">
                                <span class="btn-inner--icon"><img src="img/icons/common/github.svg"></span>
                                <span class="btn-inner--text">Github</span>
                            </a>
                            <a href="#" class="btn btn-neutral btn-icon">
                                <span class="btn-inner--icon"><img src="img/icons/common/google.svg"></span>
                                <span class="btn-inner--text">Google</span>
                            </a>
                        </div>
                    </div> -->

                    <div class="card-body px-lg-5 py-lg-5">
                        <div class="text-center mb-3">
                            <h3>{{texts.resetpass}}</h3>
                        </div>
                         <div class="text-center mb-4">
                            <medium v-if="errors" style="color: red;">{{errors}}</medium>
                        </div>
                        <div class="text-center mb-4">
                            <medium v-if="localerrors" style="color: red;">{{localerrors}}</medium>
                        </div>
                          <form v-on:submit.prevent="onSubmit(email);">
                            <fieldset class="form-group">
                            <input addon-left-icon="ni ni-email-83"
                                        :placeholder="texts.email"
                                        type="email"
                                        v-model="email"

                                        v-bind:class="{ 'form-control':true, 'is-invalid' : !validEmail(email)&& emailBlured}"
                                         v-on:blur="emailBlured = true"
                                        >
                            </input>
                        </fieldset>
<fieldset class="form-group">
                            <!-- <input class="form-control"
                                        placeholder="Password"
                                        type="password"

                                        v-model="password">
                            </input> -->
                        </fieldset>

                            <!-- <base-checkbox class="custom-control-alternative">
                                <span class="text-muted">Remember me</span>
                            </base-checkbox> -->
                            <div class="text-center">
                                <button v-if="!isLoading || errors" type="primary" class="btn btn-primary my-1 px-lg-7" >{{texts.resetpass}}</button>
                                <button v-if="isLoading" type="primary"  class="btn btn-primary my-1 px-lg-7">Loading..</button>
                                <br>
                                <br>

                            </div>
                        </form>

                    </div>
                    <!-- <div class="text-left">
                      <a v-on:click="back()">{{texts.back}}</a>
                      </div> -->
                </div>
                <br>
                <div class="text-left">
                  <u><a v-on:click="back()" class="text-light" >{{texts.back}}</a></u>
                  </div>
                <!-- <div class="row mt-3">
                    <div class="col-6">
                        <a href="#" class="text-light">
                            <large>Forgot password?</large>
                        </a>
                    </div>

                </div> -->
                <!-- <div class="row mt-3">
                    <div class="col-6">
                        <a href="#" class="text-light"><small>Forgot password?</small></a>
                    </div>
                    <div class="col-6 text-right">
                        <router-link to="/register" class="text-light"><small>Create new account</small></router-link>
                    </div>
                </div> -->
            </div>
        </div>
</template>
<script>
  import { mapState } from "vuex";
  import { FORGOT_PASSWORD } from "@/store/actions.type";
  import store from "@/store";
  import UserService from "@/common/user.service";

  export default {
    name: 'login',
    data() {
      return {
        texts : {
          email : UserService.getLanguage() === "rtl" ? "البريد الإلكتروني" : "Email",
          resetpass : UserService.getLanguage() === "rtl" ? "إعادة تعيين كلمة السر" : "Reset Password",
          back : UserService.getLanguage() === "rtl" ? "رجوع" : "Back",
        },
        language : UserService.getLanguage() || "ltr",
        email: '',
        password: '',
        isLoading: false,
        localerrors : null,
        emailBlured : false,
            valid : false

      }
    },
    methods: {
      back() {
        window.history.back();
        // this.$router.push({ name: 'sendsms' });
      },
        validate : function(){
          this.emailBlured = true;
           if( this.validEmail(this.email)){
              this.valid = true;
           }
        },
        validEmail : function(email) {
            if (email !== '') {
                var re = /(.+)@(.+){2,}\.(.+){2,}/;
                return re.test(email.toLowerCase());
            }
            else {
                return true;
            }

        },
        onSubmit() {
            if (this.email !== '') {
                this.localerrors = null;
                let email = this.email;
                Promise.all([
                  store.dispatch(FORGOT_PASSWORD, { email }),

                ]).then((data) => {
                  if (Number(data[0]['errFlag']) === 0) {
                    this.localerrors = "";
                    // this.$notify({
                    //   type: 'success',
                    //   title: data[0]['data']['message']
                    // });
                    this.isLoading = false;
                    this.$router.push({ name: "validateotp" });
                  }
                  else {
                    this.$notify({
                      type: 'warning',
                      title: data[0]['errMsg']
                    });
                  }
                });
            }
            else {

              this.localerrors = "Email cannot be empty !"

            }

          // this.$store
          //   .dispatch(LOGIN, { email, password })
          //   .then(() => this.$router.push({ name: "dashboard" }));
        }
    },
      computed: {

        ...mapState({
          errors: state => state.auth.errors
        })
      },
      mounted() {
         Promise.all([
                  store.dispatch(LOGOUT)

                ]).then(() => {

                });
      }
  };
</script>
<style>
</style>
